import React from "react";
import LoginContainer from "../../containers/Login";

function Login(props) {
  return <LoginContainer {...props} />;
}

export default Login;
